import cloneDeep from 'lodash/cloneDeep'
import * as AppConst from './AppConst'

const initialState = {
  tagInformation: {},
  applicationPlatformList: [],
  imageList: [],
  beltImageList: [],
  currentTab: 1 // 默认在 标签tab 页
}

export default function (state = initialState, action) {
  const newState = cloneDeep(state)

  switch (action.type) {
    case AppConst.GET_TAG_INFORMATION:
      newState.tagInformation = action.data
      return newState

    case AppConst.UPDATE_APPLICATION_PLATFORM_LIST:
      newState.applicationPlatformList = action.data
      return newState

    case AppConst.UPDATE_IMGAE_LIST:
      newState.imageList = action.data
      return newState

    case AppConst.UPDATE_BELT_IMGAE_LIST:
      newState.beltImageList = action.data
      return newState

    case AppConst.CHANGE_TAB:
      newState.currentTab = action.data
      return newState

    default:
      return state
  }
}
